var m = require('mithril');
var prop = require('mithril/stream')
var loaders = require('../layout/components/loaders');

module.exports = {
  oninit: function(vnode){
    vnode.state.loaderAnimation = prop(false)
    vnode.state.showCheck = prop(false)
    vnode.state.showError = prop(false)
    vnode.state.requestPending = prop(false)
  },

  view: function (vnode) {
    var ctrl= this
    ctrl.options = vnode.attrs
    var showFeedback = ctrl.options.showFeedback !== false;
    var disabledByOptions = typeof ctrl.options.disabled === 'function' ? ctrl.options.disabled() : Boolean(ctrl.options.disabled);
    var disabled = disabledByOptions || vnode.state.requestPending();
    var className = ctrl.options.class || '';
    if (disabled) className += ' o-50';
    var style = Object.assign({}, ctrl.options.style || {});
    if (disabled) style.cursor = 'not-allowed';

    var element = m("div.f4.ba.bw1.ph3.pv2.tc.v-btm.", {
      class: className,
      style: style,
      'aria-disabled': disabled ? 'true' : 'false',
      tabindex: disabled ? -1 : ctrl.options.tabindex,
      onclick: function(evt){
        // Check the stream as well as the value captured by this render. A
        // second click can arrive before Mithril redraws the disabled state.
        if (disabled || vnode.state.requestPending()) {
          if (evt && typeof evt.preventDefault === 'function') evt.preventDefault();
          return;
        }
        if(typeof ctrl.options.func == 'function'){
          var result = ctrl.options.func(evt);
          if(typeof result?.then === 'function'){
            vnode.state.requestPending(true);
            if (showFeedback) vnode.state.loaderAnimation(true);

            Promise.resolve(result)
            .then(()=>{
              if (!showFeedback) return;
              vnode.state.loaderAnimation(false);
              vnode.state.showCheck(true);
            })
            .catch((e)=>{
              if (!showFeedback) return;
              console.error(e);
              vnode.state.loaderAnimation(false);
              vnode.state.showError(true);
            })
            .finally(()=>{
              vnode.state.requestPending(false);
              m.redraw();
              if (!showFeedback) return;
              setTimeout(()=>{ 
                vnode.state.showCheck(false);
                vnode.state.showError(false);
                m.redraw();
              }, 1000);
            })
          }
        }else{
          return 
        }
      },
      href: ctrl.options.href,
      config: ctrl.options.config
      },

      (function () {
        if (ctrl.options.icon) {
          return m('div.dim.flex.justify-between', [
            ctrl.options.label,
            m('i.f4.mh1.' + ctrl.options.icon)
          ]);
        } else {
          return  m('div.flex.items-center.justify-center', [
            m('div.dim.justify-between', { style: { display: showFeedback && (vnode.state.loaderAnimation() || vnode.state.showCheck() || vnode.state.showError()) ? 'none': 'inline'}},
            [
              ctrl.options.label
            ]),
            m('i.ml2.ion-checkmark.green', { style: { display: showFeedback && vnode.state.showCheck() ? 'inline': 'none'}}),
            m('i.ml2.ion-close-round.red', { style: { display: showFeedback && vnode.state.showError() ? 'inline': 'none'}}),
            m('div.dim.justify-between.ml2', {style: { display: showFeedback && (vnode.state.loaderAnimation() || loaders.submit.show()) ? 'inline': 'none'}}, [
              m('img.h1', {src: '/images/loading-bars.svg'})
            ])
          ])
        }
      })()
    )

    if (ctrl.options.href) {
      return m('a.dim', {href: ctrl.options.href, config: ctrl.options.config || m.route}, element);
    } else {
      return element;
    }
  }
};
